import { useMemo } from 'react'

import { providersIcons } from 'components/GamesNavBar/components/Icons/components/Providers/providers'
import { Category } from 'containers/GamesBlock/types'

import useCategories from './useCategories'

export default function useProvidersWithIcons() {
  const { data } = useCategories()
  const providers = useMemo(() => matchProvidersWithIcons(data ?? []), [data])

  return providers
}

function matchProvidersWithIcons(categories: Category[]) {
  return categories
    .filter((category) => category.isProvider)
    .map((category) => ({
      ...category,
      icon: providersIcons.find(({ value }) => value === category.slug)!.icon,
    }))
    .filter(({ icon }) => !!icon)
}
